<template>
  <div>
    <craft-header
      :actIndex="actIndex"
      :imgList="imgList"
      :topStyle="topStyle"
      :logo="logo"
      :titleObj="titleObj"
    >
    </craft-header>
    <craft-center></craft-center>
    <craft-footer :bottom="bottom" :bottomInfo="bottomInfo"></craft-footer>
  </div>
</template>

<script>
import CraftHeader from "@/components/mobile/Header";
import CraftCenter from "@/components/mobile/CraftCenter"
import CraftFooter from "@/components/mobile/Footer";

export default {
  data() {
    return {
      topStyle: "",
      actIndex: 2,
      noLine: true,
      imgList: [],
      bottom: {},
      logo: "",
      bottomInfo: {},
      about: {},
      culture: {},
      developList: [],
      teamList: [],
      partner: [],
      titleObj:{title:'智慧营销体系'}
    };
  },
  mounted() {
    this.Pc_Mobile();
    this.getPageData();
  },
  components: {
    CraftHeader,
    CraftCenter,
    CraftFooter,
  },
  methods: {
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    Pc_Mobile() {
      if (this._isMobile()) {
        this.$router.push("/m_craftProduct");
      } else {
        this.$router.push("/craftProduct");
      }
    },
    getPageData() {
      this.$http.post("home/index/m_aboutpag", null, (res) => {
        // console.log(res.data)
        this.bottom = res.data.bottom[0];
        this.logo = this.bottom.logo;
        this.topStyle =
          "background:url('" +
         require('../../static/images/product/m_zhihui.png')+"')";
        this.about = res.data.company[0];
        this.culture = res.data.culture[0];
        this.developList = res.data.develop;
        this.teamList = res.data.team;
        this.partner = res.data.partner;
        this.bottomInfo = res.data.contact[0];
    
      });
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/mobile/CraftProduct.vue